export default [
  {
    path: '/mall',
    name: 'mall',
    component: () => import('@/views/page/mall.vue'),
    meta: {
      title: '在线商城'
    }
  },
  {
    path: '/mall_order',
    name: 'mall_order',
    component: () => import('@/views/page/mall/order'),
    meta: {
      title: '在线商城'
    }
  },
  {
    path: '/sku_detail/:sku_id',
    name: 'sku_detail',
    component: () => import('@/views/page/mall/sku_detail'),
    meta: {
      title: '在线商城'
    }
  },
  {
    path: '/mall_success',
    name: 'mall_success',
    component: () => import('@/views/page/mall/success'),
    meta: {
      title: '购买成功'
    }
  },
  {
    path: '/mall_order_list',
    name: 'order_list',
    component: () => import('@/views/page/mall/order_list'),
    meta: {
      title: '订单'
    }
  }
]
